import { render, staticRenderFns } from "./TransfersBlocks.vue?vue&type=template&id=753ec022&scoped=true&"
import script from "./TransfersBlocks.vue?vue&type=script&lang=js&"
export * from "./TransfersBlocks.vue?vue&type=script&lang=js&"
import style0 from "./TransfersBlocks.vue?vue&type=style&index=0&id=753ec022&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753ec022",
  null
  
)

export default component.exports